export enum EnumEstadoOperacionConciliar {
  PdteFormalizacion = 1,
  Formalizado,
  FormalizadoModificacion,
  FormalizadoAnulacion,
  Eliminado,
  Anulado,
  NoConciliado,
  PdteConciliar
}

export enum EnumEstadoOperacionBuyAndSell {
  DP = 1,
  FP,
  FD,
  PendienteRenvio,
  PdteFormalizacion,
  Formalizado,
  FormalizadoModificacion,
  FormalizadoAnulacion,
  Eliminado,
  Anulado,
  NoConciliado,
  PdteConciliar,
  Rechazado,
  Borrador
}

export enum EnumEstadoOperacionBuyAndSellSearchFilter {
  DP = 1,
  FP,
  FD,
  PendienteRenvio,
  PdteFormalizacion = 5,
  Formalizado,
  FormalizadoModificacion,
  FormalizadoAnulacion,
  Eliminado,
  Anulado,
  NoConciliado,
  PdteConciliar,
  Rechazado,
  Borrador = 14
}
